import { cx } from './cx';
import styles from './Feedback.module.css';

/** Hinweis, wenn eine Liste leer ist oder nichts gefunden wurde */
export function EmptyState({ icon: Icon, title, description, action, className }) {
  return (
    <div className={cx(styles.empty, className)}>
      {Icon && <div className={styles.emptyIcon}><Icon aria-hidden /></div>}
      <p className={styles.emptyTitle}>{title}</p>
      {description && <p className={styles.emptyText}>{description}</p>}
      {action && <div className={styles.emptyAction}>{action}</div>}
    </div>
  );
}

/** Platzhalter während des Ladens */
export function Skeleton({ width = '100%', height = 16, radius, className }) {
  return (
    <span
      aria-hidden
      className={cx(styles.skeleton, className)}
      style={{ width, height, borderRadius: radius }}
    />
  );
}

export function SkeletonText({ lines = 3 }) {
  return (
    <span className={styles.lines} aria-hidden>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} width={i === lines - 1 ? '60%' : '100%'} />
      ))}
    </span>
  );
}

/** Seitenkopf mit Titel, Untertitel, Zurück-Knopf und Aktionen */
export function PageHeader({ title, subtitle, back, actions, className }) {
  return (
    <header className={cx(styles.header, className)}>
      <div className={styles.headerMain}>
        {back}
        <div className={styles.headerText}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </header>
  );
}
